import React, { PureComponent } from "react";
import classnames from "classnames";
import { FormattedMessage } from "@al/next/al-ex";
import PropTypes from "prop-types";

import getAppName from "~/common/utils/getAppName";

import styles from "./styles.scss";

export default class NetworkError extends PureComponent {
  handleRefresh = () => {
    if (this.props.onRefresh) {
      this.props.onRefresh && this.props.onRefresh();
    } else {
      location.reload();
    }
  };

  render() {
    const { className, style } = this.props;
    const appName = getAppName();
    return (
      <div
        className={classnames(styles.root, className, styles[appName])}
        style={style}
        onTouchStart={(e) => e.stopPropagation()}
      >
        <div className={styles.img} />
        <div className={styles.text}>
          <FormattedMessage keys="global:网络状况不佳，请重新刷新" />
        </div>
        <div className={styles.btn} onClick={this.handleRefresh}>
          <FormattedMessage keys="global:重新刷新" />
        </div>
      </div>
    );
  }
}

NetworkError.propTypes = {
  onRefresh: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.instanceOf(React.CSSProperties),
};
